// extracted by mini-css-extract-plugin
export var chevronIcon = "_d8-2";
export var teamName = "_d8-1";
export var teamSwitcherButton = "_d8-0";